import { ICurriculum } from 'holberton-school-intranet-api';
import * as React from 'react';
import { ReactElement, useState } from 'react';

import ErrorInline from '../common/ErrorInline';
import Icon from '../common/Icon';
import Tooltip from '../common/Tooltip';
import UniqueFieldForm from '../common/UniqueFieldForm';

interface IProps {
    canEdit: boolean;
    csrfToken: string;
    curriculum: ICurriculum;
    updateCurriculumURI: string;
}

export default function CurriculumName({
    canEdit,
    csrfToken,
    curriculum: { certified, name: initialName, studentDisplayName, status },
    updateCurriculumURI,
}: IProps): ReactElement {
    const [error, setError] = useState<string | null>(null);
    const [name, setName] = useState<string>(initialName);

    return (
        <>
            <h1 className="align-items-center d-flex gap-3">
                {certified && (
                    <Tooltip title="This curriculum is certified">
                        <Icon className="text-primary" name="check-circle" />
                    </Tooltip>
                )}

                <UniqueFieldForm
                    canEdit={canEdit}
                    csrfToken={csrfToken}
                    name="name"
                    onError={setError}
                    onUpdate={(res: ICurriculum): void => setName(res.name)}
                    requestBodyContainer="curriculum"
                    updateURI={updateCurriculumURI}
                    value={name}
                />

                <span
                    className={`fs-3 label label-${
                        status.variants[status.key]
                    } ml-2`}
                >
                    {status.human}
                </span>
            </h1>

            {studentDisplayName && (
                <div className="align-items-center d-flex gap-2" style={{ 
                    padding: '10px 14px', 
                    backgroundColor: '#f8f9fa', 
                    borderRadius: '6px',
                    border: '1px solid #dee2e6',
                    display: 'inline-flex',
                    marginTop: '16px',
                    marginBottom: '16px',
                    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)'
                }}>
                    <Icon className="text-info" name="user" fixedWidth />
                    <span className="text-muted" style={{ fontSize: '13px', fontWeight: 500 }}>
                        Student display name:
                    </span>
                    <span className="fw-600" style={{ fontSize: '14px', color: '#495057' }}>
                        {studentDisplayName}
                    </span>
                </div>
            )}

            {error && <ErrorInline error={error} />}
        </>
    );
}
